import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/en'
import notificationService from '@/utils/notification-service';
import config from '@/utils/config_util'

// Stripe configuration - load with proper key
async function loadStripe() {
  try {
    const stripeKey = config.stripe_publishable_key();
    console.log('Loading Stripe with key:', stripeKey ? stripeKey.substring(0, 20) + '...' : 'No key found');
    
    if (stripeKey && stripeKey !== 'pk_test_your_stripe_publishable_key_here') {
      // Load Stripe.js script directly
      const script = document.createElement('script');
      script.src = 'https://js.stripe.com/v3/';
      script.onload = () => {
        // Payment system loaded
        try {
          // Check if Stripe is available
          if (typeof window.Stripe === 'function') {
            // Initialize Vue Stripe plugin after Stripe.js is loaded
            Vue.prototype.$stripeKey = stripeKey;
            Vue.prototype.$stripe = window.Stripe(stripeKey);
            console.log('✅ Payment system initialized');
          } else {
            console.error('Payment system loaded but not available');
          }
        } catch (stripeError) {
          console.error('Payment system initialization error:', stripeError.message);
          // Continue without payment system - app should still work
        }
      };
      script.onerror = (error) => {
        console.error('Failed to load Stripe.js from CDN:', error);
      };
      document.head.appendChild(script);
    } else {
      console.warn('Stripe publishable key not configured or is placeholder');
    }
  } catch (error) {
    console.error('Failed to load Stripe:', error);
  }
}

Vue.use(ElementUI, { locale });

// Make the styled notification service available globally
Vue.prototype.$notificationService = notificationService;
Vue.prototype.$notify = {
  success: (options) => notificationService.success(options.title || 'Success', options.message),
  error: (options) => notificationService.error(options.title || 'Error', options.message),
  warning: (options) => notificationService.warning(options.title || 'Warning', options.message),
  info: (options) => notificationService.info(options.title || 'Info', options.message)
};

Vue.config.productionTip = false

// Initialize app with Stripe
async function initApp() {
  await loadStripe();
  
  // Wait a bit for Stripe to load from CDN
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}

initApp();
